import { AxiosError } from 'axios';
import { useMutation } from '@tanstack/react-query';

import { PostKeysResponse, useAvApi } from '@app-velocity/av-api-v2';

export const useCreateKeysMutation = () => {
  const { keys } = useAvApi();

  return useMutation<PostKeysResponse, AxiosError>({
    mutationKey: ['keys'],
    mutationFn: async () => {
      const { data } = await keys.postKeys(null);

      return data;
    },

  });
};
